import { render, staticRenderFns } from "./tipsDialog.vue?vue&type=template&id=c3a3ddf8&scoped=true"
import script from "./tipsDialog.vue?vue&type=script&lang=js"
export * from "./tipsDialog.vue?vue&type=script&lang=js"
import style0 from "./tipsDialog.vue?vue&type=style&index=0&id=c3a3ddf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a3ddf8",
  null
  
)

export default component.exports